import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { patch } from "@rails/request.js"

// Drag-to-reorder for assignment pills within a single calendar dropzone.
// Assigning/moving/unassigning is handled by the slot-select flow, not drag.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      filter: ".unassign-btn", // Ignore clicks on the 'x' button for dragging
      onUpdate: this.onReorder.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  // Persist the new pill order. The server re-renders both viewport copies of
  // the zone via Turbo Stream so the desktop/mobile twin stays in sync.
  async onReorder(event) {
    const container = event.to
    if (!container.classList.contains('calendar-dropzone')) return

    const ids = Array.from(container.querySelectorAll(':scope > [data-assignment-id]'))
      .map(el => el.dataset.assignmentId)
    if (ids.length < 2) return

    const zone = container.id.replace(/^(desktop|mobile)_/, '')
    if (!zone) return

    const response = await patch(this.urlValue, {
      body: JSON.stringify({ ids: ids, zone: zone }),
      responseKind: 'turbo-stream'
    })
    this.resyncFromError(response)
  }

  // @rails/request.js auto-renders any turbo-stream body (including server
  // error flashes); we only need to recover when the server returned a
  // non-stream error (e.g. head 422 / 500). A replace-visit re-syncs the calendar.
  resyncFromError(response) {
    if (!response || response.ok) return
    const isStream = (response.contentType || "").includes("turbo-stream")
    if (!isStream) Turbo.visit(window.location.href, { action: "replace" })
  }
}
